/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Load model into current one</h4>

<p>Load another model and add it into the current one.</p>`;

export default function UploadTooltip() {
    return h('div', { innerHTML: body });
}
